<template>
  <div class="mobile-process-box">
    <div class="mobile-steps">
      <div
        v-for="(step, index) in stepList"
        :key="index"
        class="mobile-step-item"
        :style="{
          background: `url(${step.img}) no-repeat right bottom`,
          backgroundSize: 'contain',
        }"
        @click="toHref(index)"
      >
        <div class="mobile-step-number">{{ `0${index + 1}` }}</div>
        <div
          v-for="(title, titleIndex) in step.title"
          :key="titleIndex"
          class="mobile-step-title"
        >
          {{ title }}
        </div>
        <div class="mobile-step-more">MORE</div>
        <!-- <div class="mobile-step-description">
          <img :src="step.img" alt="" />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stepList: [
        {
          title: ["品牌", "设计"],
          img: require("@/assets/mobile/home/design.png"),
        },
        {
          title: ["系统", "开发"],
          img: require("@/assets/mobile/home/sys.png"),
        },
        {
          title: ["高端网站", "定制开发"],
          img: require("@/assets/mobile/home/web.png"),
        },
        {
          title: ["微信", "平台开发"],
          img: require("@/assets/mobile/home/wx.png"),
        },
        {
          title: ["APP", "开发"],
          img: require("@/assets/mobile/home/app.png"),
        },
      ],
    };
  },
  methods: {
    toHref(index) {
      this.$router.push({
        path: "/phone/business",
        query: { type: index },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.mobile-process-box {
  width: 46.875rem;
  background: #161616;
}

.mobile-process-box .mobile-steps .mobile-step-item {
  padding-left: 7.3rem;
  padding-top: 7.0625rem;
  position: relative;
  height: 38.5625rem;
}

.mobile-process-box .mobile-steps .mobile-step-item .mobile-step-number {
  font-weight: 400;
  font-size: 1.75rem;
  color: #ffffff;
  opacity: 0.1;
  margin-bottom: 2.5rem;
}

.mobile-process-box .mobile-steps .mobile-step-item .mobile-step-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 2.25rem;
  color: #ffffff;
  line-height: 2.875rem;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.mobile-process-box .mobile-steps .mobile-step-item .mobile-step-more {
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: underline;
  display: block;
}

.mobile-process-box .mobile-steps .mobile-step-item .mobile-step-description {
  width: 32.8125rem;
  height: 16.875rem;
  background: radial-gradient(
    circle at center,
    rgba(255, 207, 160, 0.1) 0%,
    rgba(13, 13, 13, 0) 70%
  );
}

.mobile-process-box
  .mobile-steps
  .mobile-step-item
  .mobile-step-description
  img {
  width: 100%;
}

.mobile-process-box .mobile-steps .mobile-step-item:last-child::after {
  display: none;
}

.mobile-process-box .mobile-steps .mobile-step-item:not(:first-child) {
  padding-top: 3.1875rem;
}

.mobile-process-box .mobile-steps .mobile-step-item:nth-child(2n) {
  padding-right: 7.3rem;
}

.mobile-process-box
  .mobile-steps
  .mobile-step-item:nth-child(2n)
  .mobile-step-number {
  text-align: right;
}

.mobile-process-box
  .mobile-steps
  .mobile-step-item:nth-child(2n)
  .mobile-step-title {
  text-align: right;
}

.mobile-process-box
  .mobile-steps
  .mobile-step-item:nth-child(2n)
  .mobile-step-more {
  text-align: right;
}
</style>
